<template>
  <v-container fluid style="padding: 12px">
    <v-card class="pa-0 mt-3 mb-5 ma-0" elevation="0">
      <v-row>
        <v-col class="my-0 py-0" col="2">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="bankFilterArray"
            :label="this.$t('cards.banks')"
            :items="banks"
            itemText="bankName"
            itemValue="bankId"
            :prepend-icon="'mdi-bank'"
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" col="2">
          <BranchCmbxFilter
            ref="branchFilter"
            v-model="branchFilterArray"
            :bankFilterArray="bankFilterArray"
          />
        </v-col>

        <v-col class="my-0 py-0" col="2">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="deviceTypesFilterArray"
            :label="this.$t('referenceBooks.devices.DeviceTypeName')"
            :items="deviceTypes"
            itemText="deviceTypeName"
            itemValue="deviceType"
            :prepend-icon="'mdi-state-machine'"
            style="z-index: 200"
          />
        </v-col>

        <v-col class="my-0 py-0" col="2">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="statusTypesFilterArray"
            :label="this.$t('referenceBooks.devices.Status')"
            :items="statusTypes"
            itemText="statusName"
            itemValue="deviceStatusId"
            translate
            :localizationFunc="
              (val) => $t('devicestatusNames.statusName' + val.deviceStatusId)
            "
            :prepend-icon="'mdi-clock-outline'"
            style="z-index: 200"
          />
        </v-col>

        <v-col class="my-0 py-0" col="2">
          <v-text-field
            :label="this.$t('referenceBooks.devices.SN')"
            :value="serialNumberFilter"
            @change="(v) => (serialNumberFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (serialNumberFilter = '')"
            :prepend-icon="'mdi-credit-card-outline'"
          />
        </v-col>
        <v-col class="my-0 py-0" col="2">
          <v-text-field
            :label="this.$t('referenceBooks.devices.Name')"
            :value="deviceNameFilter"
            @change="(v) => (deviceNameFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (deviceNameFilter = '')"
            :prepend-icon="'mdi-credit-card-outline'"
          />
        </v-col>
        <SearchButtons
          v-on:clear="clearFilter"
          v-on:get="getDevices"
        />
      </v-row>
    </v-card>
    <v-row align="center"> </v-row>
    <v-row class="ma-0 pa-0" align="center">
      <v-col class="d-flex mb-0 pb-0 pa-0" cols="12" sm="12">
        <v-container class="mb-0 pb-0 mr-0 pr-0 ml-0 pl-0" fluid>
          <v-card>
            <v-card-title class="mb-0 pb-0 mt-2 pt-0">
              <v-row>
                <v-select
                  class="mt-8 mr-4 ml-10"
                  style="max-width:120px;"
                  v-model="intervalTime"
                  :items="intervalTimeValues"
                  :label="this.$t('cards.refresh')"
                />
                <v-select
                  v-on:change="getDevices"
                  class="mt-8 mr-4 ml-1"
                  style="max-width:120px;"
                  v-model="limit"
                  :items="limitValues"
                  :label="this.$t('cards.rowsPerPage')"
                  item-text="value"
                  item-value="value"
                />
              </v-row>
            </v-card-title>
            <LoadIcon v-if="loading" />
            <v-data-table
              fixed-header
              v-model="selected"
              :headers="devicesHeaders"
              :items="devices"
              :disable-pagination="true"
              :sort-by.sync="currentSort"
              :sort-desc.sync="currentSortDesc"
              :custom-sort="customSort"
              item-key="deviceId"
              hide-default-footer
              :loading="loading"
              loading-text="Loading... Please wait"
              :height="tableHeight"
            >
              <template v-slot:item.deviceStatus="{ item }">
                <span
                  v-if="item.deviceStatusId === 3"
                  style="color: red; font-weight: bold"
                  >{{
                    $t("devicestatusNames.statusName" + item.deviceStatusId)
                  }}</span
                >
                <span
                  v-else-if="item.deviceStatusId === 1"
                  style="color: green; font-weight: bold"
                  >{{
                    $t("devicestatusNames.statusName" + item.deviceStatusId)
                  }}</span
                >
                <span
                  v-else-if="item.deviceStatusId === 2"
                  style="color: orange; font-weight: bold"
                  >{{
                    $t("devicestatusNames.statusName" + item.deviceStatusId)
                  }}</span
                >
                <span
                  v-else-if="item.deviceStatusId === 5"
                  style="color: red; font-weight: bold"
                  >{{
                    $t("devicestatusNames.statusName" + item.deviceStatusId)
                  }}</span
                >
                <span v-else style="color: gray; font-weight: bold">{{
                  $t("devicestatusNames.statusName" + item.deviceStatusId)
                }}</span>
              </template>

              <template v-slot:item.updateTime="{ item }">
                {{ item.updateTime | formattedDate }}
              </template>
              <template v-slot:item.embosserRemainingPercent="{ item }">
                <v-progress-circular
                  :value="item.embosserRemainingPercent"
                  v-if="
                    item.embosserRemainingPercent <= 10 &&
                      item.embosserRemainingPercent >= 0
                  "
                  style="color: red; font-weight: bold"
                  >{{ item.embosserRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.embosserRemainingPercent"
                  v-else-if="
                    item.embosserRemainingPercent > 10 &&
                      item.embosserRemainingPercent <= 30
                  "
                  style="color: orange; font-weight: bold"
                  >{{ item.embosserRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.embosserRemainingPercent"
                  v-else-if="item.embosserRemainingPercent > 30"
                  style="color: green; font-weight: bold"
                  >{{ item.embosserRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.embosserRemainingPercent"
                  v-else-if="item.embosserRemainingPercent == -1"
                  style="color: lightgray; font-weight: bold"
                  >{{ "n/a" }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.embosserRemainingPercent"
                  v-else
                  style="color: gray; font-weight: bold"
                  >{{ item.embosserRemainingPercent }}</v-progress-circular
                >
              </template>

              <template v-slot:item.printerRemainingPercent="{ item }">
                <v-progress-circular
                  :value="item.printerRemainingPercent"
                  v-if="
                    item.printerRemainingPercent <= 10 &&
                      item.printerRemainingPercent >= 0
                  "
                  style="color: red; font-weight: bold"
                  >{{ item.printerRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.printerRemainingPercent"
                  v-else-if="
                    item.printerRemainingPercent > 10 &&
                      item.printerRemainingPercent <= 30
                  "
                  style="color: orange; font-weight: bold"
                  >{{ item.printerRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.printerRemainingPercent"
                  v-else-if="item.printerRemainingPercent > 30"
                  style="color: green; font-weight: bold"
                  >{{ item.printerRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.printerRemainingPercent"
                  v-else-if="item.printerRemainingPercent == -1"
                  style="color: lightgray; font-weight: bold"
                  >{{ "n/a" }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.printerRemainingPercent"
                  v-else
                  style="color: gray; font-weight: bold"
                  >{{ item.printerRemainingPercent }}</v-progress-circular
                >
              </template>

              <template v-slot:item.indentRemainingPercent="{ item }">
                <v-progress-circular
                  :value="item.indentRemainingPercent"
                  v-if="
                    item.indentRemainingPercent <= 10 &&
                      item.indentRemainingPercent >= 0
                  "
                  style="color: red; font-weight: bold"
                  >{{ item.indentRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.indentRemainingPercent"
                  v-else-if="
                    item.indentRemainingPercent > 10 &&
                      item.indentRemainingPercent <= 30
                  "
                  style="color: orange; font-weight: bold"
                  >{{ item.indentRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.indentRemainingPercent"
                  v-else-if="item.indentRemainingPercent > 30"
                  style="color: green; font-weight: bold"
                  >{{ item.indentRemainingPercent }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.indentRemainingPercent"
                  v-else-if="item.indentRemainingPercent == -1"
                  style="color: lightgray; font-weight: bold"
                  >{{ "n/a" }}</v-progress-circular
                >
                <v-progress-circular
                  :value="item.indentRemainingPercent"
                  v-else
                  style="color: gray; font-weight: bold"
                  >{{ item.indentRemainingPercent }}</v-progress-circular
                >
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
    <v-row align="start">
      <v-col class="d-flex">
        <v-row style="display: flex; justify-content: center">
          <v-pagination
            v-on:input="getDevicesAndStartTimer"
            v-model="page"
            :length="paginationLength"
            :total-visible="totalVisible"
          />
        </v-row>
      </v-col>
      <p class="d-flex v-card__title">
        {{ $t("cards.records") }} {{ $t("from") }} {{ limit * (page - 1) + 1 }}
        {{ $t("to") }} {{ limit * page }}
      </p>
      <p align="right" class="d-flex v-card__title">
        {{ $t("cards.total") }}: {{ totalCount }}
      </p>
    </v-row>
  </v-container>
</template>

<script>
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';
import LoadIcon from '@/components/LoadIcon';
import formatDate from '@/services/dateFormatter';
import { NamesDB } from '@/constants/DBNames.js';
import SearchButtons from '../components/FiltersComponent/SearchButtons';
import BranchCmbxFilter from '@/components/FiltersComponent/FinishedFilters/BranchCmbxFilter';
import tableHeightMixin from './mixins/tableHeightMixin';

export default {
  name: 'Devices',
  mixins: [tableHeightMixin],
  data() {
    return {
      waitingDevicesResponse: false,

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 64,
      filterH: 140,
      tHeaderH: 40,
      tFooterH: 42,

      manageCardDialogKey: 0,

      // Переменная видимости фильтра
      showFullFilter: false,

      // Необходимо для определения
      cardActionsMode: 0,
      actions: [],

      // Настройки интервала обновления таблицы таблицы
      intervalTime: 30,

      interval: {},
      lastSync: '',

      showDisabledDevices: false,
      // Переменные для
      page: 1,
      limit: 10,

      paginationLength: 100,

      totalCount: '',
      totalVisible: 10,

      selected: [],
      singleSelect: false,

      cardPriorities: [],
      banks: [],
      branches: [],
      devices: [],
      products: [],
      devicesDesigns: [],
      jobs: [],

      loading: false,
      loadingTest: false,

      cardPrioritiesFilter: 0,
      cardPrioritiesFilterArray: [],
      bankFilter: 0,
      bankFilterArray: [],
      branchFilter: 0,
      branchFilterArray: [],
      productFilterArray: [],
      devicesFilterArray: [],
      jobFilterArray: [],
      panFilter: '',
      cardholderFilter: '',
      jobDateFilter: [],
      attachProductToDeviceDialogKey: 0,
      showProductsDialog: false,
      showProducts: false,
      loadingDevices: false,
      loadingProducts: false,
      dialog: true,
      selectedDevice: [],
      devicesSingleSelect: true,
      noDevices: false,
      noProducts: false,
      testVal: 1,

      pinDeviceToAnotherBranchDialogKey: 0,

      deviceFilter: '',
      deviceTypesFilterArray: [],
      deviceTypes: [],
      statusTypesFilterArray: [],
      statusTypes: [],
      serialNumberFilter: '',
      deviceNameFilter: '',

      changedDevicesId: [],

      productsByBanks: [],

      sortBy: [],
      sortDesc: [],
      tempDevices: [],

      selectedProducts: [],
      productsSingleSelect: false,

      lastSort: 'deviceName',
      currentSortDesc: [],
      currentSort: [],

      isMounted: false,
    };
  },
  filters: {
    formattedDate(dateString) {
      return formatDate(dateString);
    },
  },
  watch: {
    async currentSortDesc() {
      if (!this.isMounted) return;
      this.getDevices();
    },
    async currentSort(val) {
      if (!this.isMounted) return;
      if (val.length != 0) {
        this.lastSort = val[0];

        this.getDevices();
      }
    },
    branchFilterArray: async function() {
      this.checkBankFilter();
      if (this.isMounted && this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBranchFilter(this.branchFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
    },
    bankFilterArray: async function() {
      this.products = [];
      if (this.isMounted && this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
        this.$localStorageObj.setBankFilter(this.bankFilterArray, this.pageKey, this.$store.getters.USERNAME);
      }
    },

    intervalTime: function() {
      this.$localStorageObj.setIntervalTime(this.intervalTime);
      this.getDevicesAndStartTimer();
    },
    limit: function() {
      this.page = 1;
    },
    filterJson() {
      // Avoid early requests while default status filter is still initializing.
      if (!this.isMounted) return;
      this.page = 1;
      this.getDevicesAndStartTimer();
    },
    devices(val) {
      this.selected = this.selected.filter((item) =>
        this.hasInArray(item, val)
      );
    },
  },
  computed: {
    pageKey() {
      return this.$route.path;
    },
    intervalTimeValues() {
      return this.$store.getters.UPDATE_FREQUENCY;
    },
    limitValues() {
      var res = this.$store.getters.COUNT_ROWS;

      if (res === undefined || res === null || res.length === 0)
        return [
          { value: 10 },
          { value: 25 },
          { value: 50 },
          { value: 500 },
          { value: 2000 },
          { value: 5000 },
        ];

      return res;
    },

    devicesHeaders() {
      let result = [
        {},
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.branches.Name'),
          value: 'branchName',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Name'),
          value: 'deviceName',
          width: '200px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.DeviceTypeName'),
          value: 'deviceTypeName',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.SN'),
          value: 'sn',
          width: '100px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.lastSync'),
          value: 'updateTime',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Link'),
          value: 'link',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Status'),
          value: 'deviceStatus',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.mIleage'),
          value: 'mIleage',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.embosserRibbon'),
          value: 'embosserRemainingPercent',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.devices.indentRibbon'),
          value: 'indentRemainingPercent',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.devices.printerRibbon'),
          value: 'printerRemainingPercent',
          sortable: false,
        },
      ];

      if (this.$store.getters.RIGHTS_ON_BANK_LEVEL) {
        result = result.filter((header) => header.value !== 'bankName');
      }
      if (this.$store.getters.RIGHTS_ON_BRANCH_LEVEL) {
        result = result.filter((header) => header.value !== 'bankName');
        result = result.filter((header) => header.value !== 'branchName');
      }

      return result;
    },
    branchesOfBanks() {
      if (this.bankFilterArray.length === 0) return this.branches;

      return this.branches.filter((branch) => {
        return this.bankFilterArray.some(
          (bank) => bank.bankId === branch.bankId
        );
      });
    },
    filterJson() {
      const result = {};
      result.branchesId = this.branchFilterArray.map(
        (branch) => branch.branchId
      );
      result.banksId = this.bankFilterArray.map((bank) => bank.bankId);
      result.deviceTypesId = this.deviceTypesFilterArray.map(
        (device) => device.deviceTypeId
      );
      result.deviceStatusId = this.statusTypesFilterArray.map(
        (status) => status.deviceStatusId
      );
      result.Sn = !this.serialNumberFilter ? '' : this.serialNumberFilter;
      result.deviceName = !this.deviceNameFilter ? '' : this.deviceNameFilter;

      return result;
    },
    OrderBy() {
      const Sort = [];

      if (this.currentSort.length == 0) this.restoreSort();

      for (let i = 0; i < this.currentSort.length; i++) {
        Sort.splice(0, 0, {
          Name: NamesDB[this.currentSort[i]],
          SortUp: !this.currentSortDesc[i],
        });
      }

      return { Sort };
    },
  },
  async mounted() {
    this.intervalTime = this.$localStorageObj.getIntervalTime();
    this.setDefaultSort();

    await this.$axios.banks
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.banks = json;
      })
      .catch((error) => {
        console.error(error);
      });

    if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
      const savedBankFilter = this.$localStorageObj.getBankFilter(this.pageKey, this.$store.getters.USERNAME);
      const savedBranchFilter = this.$localStorageObj.getBranchFilter(this.pageKey, this.$store.getters.USERNAME);

      if (savedBankFilter && savedBankFilter.length > 0) {
        const savedBankIds = savedBankFilter.map(b => b.bankId || b);
        this.bankFilterArray = this.banks.filter(bank =>
          savedBankIds.includes(bank.bankId)
        );
      } else if (this.banks.length === 1) {
        this.bankFilterArray.push(this.banks[0]);
      }

      if (savedBranchFilter && savedBranchFilter.length > 0 && this.bankFilterArray.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const savedBranchIds = savedBranchFilter.map(b => b.branchId || b);
            if (this.$refs.branchFilter && this.$refs.branchFilter.branches && this.$refs.branchFilter.branches.length > 0) {
              this.branchFilterArray = this.$refs.branchFilter.branches.filter(branch =>
                savedBranchIds.includes(branch.branchId)
              );
            }
          }, 800);
        });
      }
    } else if (this.banks.length === 1) {
      this.bankFilterArray.push(this.banks[0]);
    }

    await this.$axios.deviceTypes
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.deviceTypes = json;
      })
      .catch((error) => {
        console.error(error);
      });

    await this.$axios.statusTypes
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.statusTypes = json;
        this.statusTypesFilterArray = this.statusTypes.filter(
          (val) => val.deviceStatusId !== 0
        );
      })
      .catch((error) => {
        console.error(error);
      });

    await this.getDevices();
    this.startTimer();

    // Пересчитать высоту таблицы после полного рендера всех элементов
    this.$nextTick(() => {
      setTimeout(() => {
        this.handleResize();
      }, 100);
    });

    this.isMounted = true;
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    checkBankFilter() {
      const newBankId = this.getNewFilterBankIdByBranches();

      if (newBankId && newBankId.length > 0)
        this.addNewBanksToFilter(newBankId);
    },
    getNewFilterBankIdByBranches() {
      var res = [];
      const lenBr = this.branchFilterArray.length;
      const lenBank = this.bankFilterArray.length;

      for (var i = 0; i < lenBr; i++) {
        var exist = false;
        const bId = this.branchFilterArray[i].bankId;

        for (var j = 0; !exist && j < lenBank; j++)
          exist = bId === this.bankFilterArray[j].bankId;

        if (!exist && res.find((id) => bId === id) === undefined) res.push(bId);
      }

      return res;
    },
    addNewBanksToFilter(newBanksId) {
      if (!newBanksId || newBanksId.length === 0) return;

      newBanksId.forEach((bankId) =>
        this.bankFilterArray.push(
          this.banks.find((bankVal) => bankVal.bankId === bankId)
        )
      );
    },
    clearFilter() {
      if (this.banks.length !== 1) {
        this.bankFilterArray = [];
        if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
          this.$localStorageObj.setBankFilter([], this.pageKey, this.$store.getters.USERNAME);
        }
      }
      if (this.branches.length !== 1) {
        this.branchFilterArray = [];
        if (this.$localStorageObj.getKeepFiltersValue(this.$store.getters.USERNAME)) {
          this.$localStorageObj.setBranchFilter([], this.pageKey, this.$store.getters.USERNAME);
        }
      }

      this.deviceTypesFilterArray = [];
      this.statusTypesFilterArray = [];
      this.serialNumberFilter = '';
    },

    getDevicesAndStartTimer(filter = undefined) {
      this.stopTimer();
      window.setTimeout(
        async function() {
          if (!this.waitingDevicesResponse) {
            this.waitingDevicesResponse = true;
            await this.getDevices(filter);
            this.waitingDevicesResponse = false;
          }
        }.bind(this),
        0
      );
      this.startTimer();
    },

    rerender() {
      this.manageCardDialogKey++;
      this.getDevicesAndStartTimer();
    },
    stopTimer() {
      this.waitingDevicesResponse = false;
      if (this.interval) {
        window.clearInterval(this.interval);
      }
    },
    startTimer() {
      this.stopTimer();
      this.interval = window.setInterval(
        async function() {
          if (!this.waitingDevicesResponse) {
            this.waitingDevicesResponse = true;
            await this.getDevices();
            this.waitingDevicesResponse = false;
          }
        }.bind(this),
        this.intervalTime * 1000
      );
    },
    async getLastSync() {
      try {
        const params = {};
        this.$axios.devices
          .getLastSync(params)
          .then(
            (response) => response.data,
            (response) => {
              if (response.status != 200) {
                console.error('getLastSync error', response);
                this.lastSync = 'NO DATA FROM SERVER';
              }
            }
          )
          .then((json) => (this.lastSync = json));
      } catch (error) {
        console.error('getLastSync error', error);
        this.lastSync = 'NO DATA FROM SERVER';
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async getDevices() {
      if (this.loading) return;
      this.loading = true;

      const page = this.page;
      let flag = false;
      const orderBy = this.OrderBy;
      try {
        const params = {
          limit: this.limit,
          offset: this.limit * (this.page - 1),
          query: JSON.stringify(this.filterJson),
        };

        if (orderBy.Sort != undefined && orderBy.Sort != null)
          params.orderby = JSON.stringify(orderBy);

        await this.$axios.devices
          .getPaginated(params)
          .then((response) => response.data)
          .then((json) => {
            if (this.page == page) {
              let i = 1;
              json.forEach((val) => (val.numb = i++));

              this.devices = json;
            } else flag = true;
          });

        this.$axios.devices
          .getCountCustom(params)
          .then((response) => response.data)
          .then((json) => {
            this.totalCount = json.totalCount;
            this.paginationLength = Math.ceil(json.totalCount / this.limit);
          });
      } catch (error) {
        console.error(error);
      }

      this.loading = false;
      this.testLoadVal = false;

      if (flag) this.getDevices();
    },
    async refreshDevices() {
      this.eager = !this.eager;
      await this.getDevices();
    },
    onDateChange(dateFrom, dateTo) {
      this.jobDateFilter = [];
      this.jobDateFilter.push(dateFrom);
      this.jobDateFilter.push(dateTo);
    },

    //-------------------------SORT--------------------
    setDefaultSort() {
      this.currentSort.splice(0, 0, 'deviceName');
      this.currentSortDesc.splice(0, 0, false);
    },
    restoreSort() {
      this.currentSort.splice(0, 0, this.lastSort);
      this.currentSortDesc.splice(0, 0, false);
    },
    customSort: function(items) {
      return items;
    },
  },
  components: {
    ComboboxFilter2000,
    LoadIcon,
    SearchButtons,
    BranchCmbxFilter,
  },
};
</script>
